import { render } from "./Stars.vue?vue&type=template&id=05b6a640"
import script from "./Stars.vue?vue&type=script&lang=js"
export * from "./Stars.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__